export default __webpack_public_path__ + "static/media/chart.2d419134.svg";